export default __webpack_public_path__ + "static/media/theme2.fea151fa.png";